import React from "react";

const defaultAdvocacyData = [
  { policy: "", method: "", publicInfo: "", frequency: "" },
];

const PublicPolicyAdvocacyTable = ({ advocacyData, setAdvocacyData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...advocacyData];
    updated[index][field] = value;
    setAdvocacyData(updated);
  };

  const addRow = () => {
    setAdvocacyData([
      ...advocacyData,
      { policy: "", method: "", publicInfo: "", frequency: "" },
    ]);
  };

  const removeRow = () => {
    if (advocacyData.length > 1) {
      setAdvocacyData(advocacyData.slice(0, -1));
    }
  };

  const cell = {
    border: "1px solid #000",
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  return (
    <div>
      <div
        style={{
          overflowX: "auto",
          marginTop: 20,
          border: "1px solid #000",
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={header}>S. No</th>
              <th style={header}>Public policy advocated</th>
              <th style={header}>Method resorted for such advocacy</th>
              <th style={header}>
                Whether the information available in public domain <br />
                (Yes/No)
              </th>
              <th style={header}>
                Frequency of web review by link, if board available <br />
                (Annually / Half-yearly / Quarterly / Others)
              </th>
            </tr>
          </thead>
          <tbody>
            {advocacyData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>{index + 1}.</td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Details"
                    value={row.policy}
                    onChange={(e) =>
                      handleChange(index, "policy", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Details"
                    value={row.method}
                    onChange={(e) =>
                      handleChange(index, "method", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Yes / No"
                    value={row.publicInfo}
                    onChange={(e) =>
                      handleChange(index, "publicInfo", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Details"
                    value={row.frequency}
                    onChange={(e) =>
                      handleChange(index, "frequency", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

// Button styles
const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default PublicPolicyAdvocacyTable;
